import React, {memo, useRef, useState} from "react";
import styles from "./style.module.css";
import ArmFlagSvg from "../../../../assets/SVG/ArmFlagSvg";
import USAFlagSvg from "../../../../assets/SVG/USAFlagSvg";
import RuFlagSvg from "../../../../assets/SVG/RuFlagSvg";
import ButtonArrowSvg from "../../../../assets/SVG/ButtonArrowSvg";
import GlobusSvg from "../../../../assets/SVG/GlobusSvg";
import DropDown from "../../../DropDown";
import UseOutSideClick from "../../../../helpers/UseOutSideClick";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {
    getConvertRate,
    postLang,
    setCurrentCurrency,
} from "../../../../store/MainSlice";
import lang from "../../../../lang/lang";

const languagesData = [
    {
        label: "Հայերեն",
        value: "hy",
    },
    {
        label: "English",
        value: "en",
    },
    {
        label: "Русский",
        value: "ru",
    },
];

const currencyData = [
    {
        label: "AMD",
        value: "amd",
        currency: "֏",
        convertRate: 1,
        id: 121,
    },
    {
        label: "USD",
        value: "usd",
        currency: "$",
        convertRate: null,
        id: 2,
    },
    {
        label: "RUB",
        value: "rub",
        currency: "руб",
        convertRate: null,
        id: 87,
    },
];

export default memo(function Currency({shortBtn = false}) {

    const [opened, setOpened] = useState(false);
    const {currentLanguage, currentCurrency} = useSelector(({main}) => main);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    //
    // const languageFlags = {
    //     hy: <ArmFlagSvg/>,
    //     en: <USAFlagSvg/>,
    //     ru: <RuFlagSvg/>,
    // };

    const containerRef = useRef();

    UseOutSideClick(containerRef, () => setOpened(false));

    return (
        <div
            className={styles.container}
            ref={containerRef}
            style={opened ? {zIndex: 9999} : undefined}
        >
            <div
                className={`${styles.btn} ${shortBtn && styles.shortBtn}`}
                onClick={() => setOpened(!opened)}
            >
                <GlobusSvg className={styles.socIcon}/>
                <span style={{fontSize: "18px", color: '#2828281A'}}>|</span>
                <span className={styles.btnCurrencyText}>{currentCurrency.value}</span>
                <ButtonArrowSvg className={styles.socIcon}/>
            </div>
            {opened && (
                <div className={styles.openedContainer} style={{zIndex: 100000}}>
                    {/*<p>{langData.header.langugae[currentLanguage]}</p>*/}
                    <DropDown
                        active={
                            languagesData?.find((e) => e.value === currentLanguage)?.label
                        }
                        data={languagesData}
                        setActive={(item) => {
                            if (item.value !== currentLanguage) {
                                const urlPathsArray = window.location.pathname
                                    ?.split("/")
                                    ?.filter((e) => !!e);
                                dispatch(postLang(item.value));
                                if (
                                    (item.value === "hy" || item.value === "am") &&
                                    (urlPathsArray[0] === "ru" || urlPathsArray[0] === "en")
                                ) {
                                    urlPathsArray?.shift();
                                }
                                else if (
                                    urlPathsArray[0] === "ru" ||
                                    urlPathsArray[0] === "en"
                                ) {
                                    urlPathsArray[0] = item.value;
                                }
                                else {
                                    urlPathsArray?.unshift(item.value);
                                }
                                navigate("/" + urlPathsArray.join("/") + window.location.search);
                            }
                        }}
                    />
                    {/*<p>{langData.header.сurrency[currentLanguage]}</p>*/}
                    <DropDown
                        active={currencyData.find((e) => e.value === currentCurrency.value)?.label}
                        data={currencyData}
                        setActive={(item) => {
                            if (!item.convertRate) {
                                dispatch(getConvertRate(item.id));
                            }
                            dispatch(setCurrentCurrency(item));
                        }}
                    />
                    <button
                        className={styles.confirmBtn}
                        onClick={() => {
                            setTimeout(() => {
                                setOpened(false)
                            }, 500)
                        }}
                    >
                        { lang[currentLanguage].confirm }
                    </button>
                </div>
            )}
        </div>
    );
});
